// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bhaDn2ajL7UMHSmIr5_4{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0}.VoBzqSKosyEXM7D1QE3g{overflow-y:hidden;overflow-x:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mailListShimmerStateContainer": "bhaDn2ajL7UMHSmIr5_4",
	"hideScrollContainers": "VoBzqSKosyEXM7D1QE3g"
};
module.exports = ___CSS_LOADER_EXPORT___;
